import {m} from 'framer-motion';
// @mui
import {alpha} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import {paths} from 'src/routes/paths';
import {useRouter} from 'src/routes/hooks';
// hooks
// auth
import {useAuthContext} from 'src/auth/hooks';
// components
import {varHover} from 'src/components/animate';
import {useSnackbar} from 'src/components/snackbar';
import CustomPopover, {usePopover} from 'src/components/custom-popover';
import React from "react";
import logoHeaderMatematico from 'src/assets/logo_header_inverted.svg';
import Iconify from "../../components/iconify";
import {getServerName} from "../../utils/serverName";


// ----------------------------------------------------------------------

const OPTIONS = [
  {
    label: 'Профил',
    linkTo: paths.user.root,
  },
];

if (getServerName() === 'Matematico') {
  OPTIONS.push(...[{
    label: 'Основни задачи',
    linkTo: paths.problem.list,
  },
    {
      label: 'Водещи математици',
      linkTo: paths.leaderboard,
    },
    {
      label: 'Тестове',
      linkTo: paths.tests.generate,
    },]);
}

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const router = useRouter();

  const {user} = useAuthContext();

  const {logout} = useAuthContext();

  const {enqueueSnackbar} = useSnackbar();

  const popover = usePopover();

  let options = OPTIONS;
  if (user && user.isAdmin) {
    options = [...options, {
      label: 'Админ чат',
      linkTo: paths.admin.chat,
    }, {
      label: 'Админ инструменти',
      linkTo: paths.admin.tools,
    },{
        label: 'НВО-та',
        linkTo: paths.nvo.list,
    }];

    if (getServerName() === 'Matematico') {
      options = [...options, {
        label: 'Битка на задачи',
        linkTo: paths.admin.problemFights,
      }];
    }
  } else {
    options = [...options, {
      label: 'Чат с админ',
      linkTo: paths.contacts.chat,
    }];

    if ((!user?.groupSchoolId && getServerName() === 'Matematico') && !process.env.REACT_APP_MOBILE) {
      options = [...options, {
        label: 'Абонамент',
        linkTo: paths.pricing,
      },];
    }
  }

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      router.replace('/');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', {variant: 'error'});
      router.replace('/');
    }
  };

  const handleClickItem = (path: string) => {
    popover.onClose();
    router.push(path);
  };

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 64,
          height: 64,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.inventoryData?.avatarUrl}
          alt={user?.username}
          sx={{
            width: 60,
            height: 60,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        />
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{width: 200, p: 0}}>
        <Box sx={{p: 2, pb: 1.5}}>
          <Typography variant="subtitle2" noWrap>
            {user?.username}
          </Typography>

          <Typography variant="body2" sx={{color: 'text.secondary'}} noWrap>
            {user?.email}
          </Typography>

          <Stack direction="row" sx={{typography: 'body2', mt: 1}}>
            <Iconify icon="nimbus:money" color="green" width={20}/>&nbsp;
            {user?.coins}
          </Stack>

          <Stack direction="row" sx={{typography: 'body2', mt: 1}}>
            <Iconify icon="material-symbols:diamond-outline" color="blue" width={20}/>&nbsp;
            {user?.gems}
          </Stack>

          <Stack direction="row" sx={{typography: 'body2', mt: 1}}>
            <Iconify icon="mdi:flame" color="#e25822" width={20}/>&nbsp;
            {user?.state?.dailyProblem?.streak || 0}
          </Stack>

          <Stack direction="row" sx={{typography: 'body2', mt: 1}}>
            <Iconify icon="fa6-regular:snowflake" color="#59C9FC" width={20}/>&nbsp;
            {user?.state?.dailyProblem?.freezes || 0}
          </Stack>
        </Box>

        <Divider sx={{borderStyle: 'dashed'}}/>

        <Stack sx={{p: 1}}>
          {options.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{borderStyle: 'dashed'}}/>

         {getServerName() !== 'Matematico' && (
          <Stack sx={{p: 1}}>
            {/* eslint-disable-next-line no-return-assign */}
            <MenuItem onClick={() => window.location.href = process.env.REACT_APP_MATEMATICO_URL || '/'}>
              <img src={logoHeaderMatematico} alt="Matematico" style={{width: 100}}/>
            </MenuItem>
          </Stack>
         )}

        {/* {getServerName() !== 'Examico' && ( */}
        {/*  <Stack sx={{p: 1}}> */}
        {/*    /!* eslint-disable-next-line no-return-assign *!/ */}
        {/*    <MenuItem onClick={() => window.location.href = process.env.REACT_APP_EXAMICO_URL || '/'}> */}
        {/*      <img src={logoHeaderExamico} alt="Examico" style={{width: 100}}/> */}
        {/*    </MenuItem> */}
        {/*  </Stack> */}
        {/* )} */}

        <Divider sx={{borderStyle: 'dashed'}}/>

        <MenuItem
          onClick={handleLogout}
          sx={{m: 1, fontWeight: 'fontWeightBold', color: 'error.landing'}}
        >
          Изход
        </MenuItem>
      </CustomPopover>
    </>
  );
}
